export const authError = {
    requiredAccount: "Vui lòng nhập tài khoản",
    requiredAccountName: "Vui lòng nhập tên tài khoản",
    requiredPhone: "Vui lòng nhập số điện thoại",
    requiredEmail: "Vui lòng nhập email",
    requiredPasswordConfirm: "Vui lòng nhập xác nhận mật khẩu",
    invalidAccountName: "Tên tài khoản tối thiểu 4 ký tự",
    invalidPhone: "Số điện thoại không hợp lệ",
    invalidEmail: "Email không hợp lệ",
    requiredPassword: "Vui lòng nhập mật khẩu",
    requiredNewPassword: "Vui lòng nhập mật khẩu mới",
    invalidPassword: "Mật khẩu tối thiểu tám ký tự, ít nhât 1 chữ hoa, 1 chữ thường, một số và một ký tự đặc biệt",
    invalidPasswordConfirm: "Xác nhận mật khẩu không trùng khớp",
}